"use client";

import { PDFViewer } from "@react-pdf/renderer";
import { TransportVoucherData } from "@/types/navigation";
import { TransportVoucherPDF } from "./voucherPdf";

// Aperçu PDF en direct du bon de transport. En mode édition, l'aperçu reflète
// les valeurs en cours de saisie (editedData) ; sinon le document validé (data).
type VoucherPreviewProps = {
  data: TransportVoucherData;
  editedData: TransportVoucherData | null;
  effectiveIsEditing: boolean;
};

export const VoucherPreview = ({
  data,
  editedData,
  effectiveIsEditing,
}: VoucherPreviewProps) => (
  <div
    className={`h-[70vh] min-h-[460px] w-full overflow-hidden rounded-2xl border border-black/10 bg-white shadow-[0_18px_60px_-35px_rgba(0,0,0,0.45)] md:h-[800px] ${effectiveIsEditing ? "lg:w-1/2" : "w-full"}`}
  >
    <PDFViewer style={{ width: "100%", height: "100%" }}>
      <TransportVoucherPDF data={effectiveIsEditing ? editedData! : data} />
    </PDFViewer>
  </div>
);
